<div
  #customToggle
  class="app-export-custom-toggle"
  [ngClass]="overlayMode ? 'app-export-custom-toggle__overlay' : ''"
  *transloco="let t"
>
  <mat-label class="app-export-custom-toggle__label">{{
    t("step3.eh-mydocuments-step3-custom")
  }}</mat-label>
  <mat-icon
    class="app-export-custom-toggle__icon"
    [matTooltipPosition]="'above'"
    [matTooltipShowDelay]="200"
    [matTooltipHideDelay]="200"
    [matTooltipDisabled]="isTooltipDisabled || overlayMode"
    [matTooltip]="t('step3.eh-mydocuments-step3-custom-tooltip')"
    >info</mat-icon
  >
  <div class="app-export-custom-toggle__toggle-container">
    <mat-slide-toggle
      class="app-export-custom-toggle--toggle"
      (change)="onToggleChange($event)"
      >{{ t("step3.eh-mydocuments-step3-show-settings") }}</mat-slide-toggle
    >
  </div>
</div>
